<script setup>
import { EyeIcon } from "@heroicons/vue/24/outline";
import ActionButton from "@js/components/ActionButton.vue";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const { row } = defineProps({
  row: {
    type: Object,
    required: true,
  },
});

const url = computed(() => {
  return `/${row.original.tenantId}/login?token=${row.original.loginToken}&redirectLink=${window.btoa(row.original.referenceLink)}`;
});
</script>

<template>
  <div class="flex h-full flex-row items-center gap-2 p-4">
    <ActionButton
      size="small"
      class="size-8"
      :title="t('button.see')"
      :icon="EyeIcon"
      :href="url"
      target="_blank"
    >
      {{ t("button.see") }}
    </ActionButton>
  </div>
</template>
